/* =========================================================
   CLINIQUE NOUR – KURVSPROG DA / EN
   Retter tekster i cart drawer og virker også efter AJAX-opdateringer.
========================================================= */

(() => {
  const dictionary = {
    da: {
      title: 'Kurv',
      freeShipping: 'Du har opnået gratis fragt.',
      viewCart: 'Se kurv',
      checkout: 'Gå til kassen',
      instructions: 'Særlige instruktioner til ordren',
      subtotal: 'Subtotal',
      total: 'Totalbeløb',
      remove: 'Fjern'
    },

    en: {
      title: 'Cart',
      freeShipping: 'You qualify for free shipping.',
      viewCart: 'View cart',
      checkout: 'Checkout',
      instructions: 'Special instructions for your order',
      subtotal: 'Subtotal',
      total: 'Total',
      remove: 'Remove'
    }
  };

  const knownText = {
    title: [
      'shopping bag',
      'shopping cart',
      'cart',
      'kurv'
    ],

    freeShipping: [
      'you got free shipping.',
      'you got free shipping!',
      'you qualify for free shipping.',
      'du har opnået gratis fragt.',
      'du har fået gratis fragt.'
    ],

    instructions: [
      'order special instructions',
      'special instructions for your order',
      'særlige instruktioner til ordren'
    ],

    subtotal: [
      'subtotal'
    ],

    total: [
      'total',
      'totalbeløb'
    ],

    remove: [
      'remove',
      'fjern'
    ]
  };

  const getLanguage = () => {
    const language = (
      document.documentElement.lang ||
      document.documentElement.getAttribute('lang') ||
      'da'
    ).toLowerCase();

    return language.startsWith('en') ? 'en' : 'da';
  };

  const normalizeText = (value) => {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  };

  const setButtonText = (element, text) => {
    if (!element) return;

    if (
      element instanceof HTMLInputElement &&
      ['submit', 'button'].includes(element.type)
    ) {
      element.value = text;
      element.setAttribute('aria-label', text);
      element.setAttribute('title', text);
      return;
    }

    const textElement =
      element.querySelector(
        '.button-text, [class*="button-text"], [data-button-text]'
      ) || element;

    if (normalizeText(textElement.textContent) !== normalizeText(text)) {
      textElement.textContent = text;
    }

    element.setAttribute('aria-label', text);
    element.setAttribute('title', text);
  };

  const isCartLink = (link) => {
    try {
      const url = new URL(link.href, window.location.origin);

      return url.pathname.replace(/\/+$/, '') === '/cart';
    } catch (error) {
      return false;
    }
  };

  const isCheckoutLink = (link) => {
    try {
      const url = new URL(link.href, window.location.origin);

      return url.pathname.replace(/\/+$/, '') === '/checkout';
    } catch (error) {
      return false;
    }
  };

  const replaceExactText = (
    drawer,
    candidates,
    replacement
  ) => {
    const normalizedCandidates = new Set(
      candidates.map(normalizeText)
    );

    drawer
      .querySelectorAll(
        'h1, h2, h3, h4, h5, h6, p, span, div, summary, button, a'
      )
      .forEach((element) => {
        if (element.children.length > 0) return;

        const currentText = normalizeText(element.textContent);

        if (normalizedCandidates.has(currentText)) {
          element.textContent = replacement;
        }
      });
  };

  const updateCartDrawer = () => {
    const drawer = document.querySelector('cart-drawer');

    if (!drawer) return;

    const text = dictionary[getLanguage()];

    replaceExactText(
      drawer,
      knownText.title,
      text.title
    );

    replaceExactText(
      drawer,
      knownText.freeShipping,
      text.freeShipping
    );

    replaceExactText(
      drawer,
      knownText.instructions,
      text.instructions
    );

    replaceExactText(
      drawer,
      knownText.subtotal,
      text.subtotal
    );

    replaceExactText(
      drawer,
      knownText.total,
      text.total
    );

    replaceExactText(
      drawer,
      knownText.remove,
      text.remove
    );

    drawer.querySelectorAll('a[href]').forEach((link) => {
      if (isCartLink(link)) {
        setButtonText(link, text.viewCart);
        link.dataset.cnCartButton = 'view-cart';
      }

      if (isCheckoutLink(link)) {
        setButtonText(link, text.checkout);
        link.dataset.cnCartButton = 'checkout';
      }
    });

    const checkoutButtons = drawer.querySelectorAll(
      [
        'button[name="checkout"]',
        'input[name="checkout"]',
        '[data-checkout-button]',
        '[name="checkout"]'
      ].join(',')
    );

    checkoutButtons.forEach((button) => {
      setButtonText(button, text.checkout);
      button.dataset.cnCartButton = 'checkout';
    });
  };

  let updateScheduled = false;

  const scheduleUpdate = () => {
    if (updateScheduled) return;

    updateScheduled = true;

    requestAnimationFrame(() => {
      updateScheduled = false;
      updateCartDrawer();
    });
  };

  const initializeCartLanguage = () => {
    updateCartDrawer();

    const observer = new MutationObserver(() => {
      scheduleUpdate();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener(
      'shopify:section:load',
      scheduleUpdate
    );

    document.addEventListener(
      'shopify:section:select',
      scheduleUpdate
    );

    document.addEventListener(
      'cart:updated',
      scheduleUpdate
    );

    document.addEventListener(
      'cart:refresh',
      scheduleUpdate
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeCartLanguage,
      {
        once: true
      }
    );
  } else {
    initializeCartLanguage();
  }
})();